import React from 'react';
import PropTypes from 'prop-types';

import './chatdetailcall.scss';

const ChatDetailCall = ({ ...props }) => {
  const { chatCallToggle, showCall, listingInfo, trans } = props;
  const _handleClose = () => {
    chatCallToggle();
  };

  const showCallClass = showCall ? 'show' : 'hide';
  let agentList = '';
  let officeList = '';
  if (Object.keys(listingInfo.agents).length > 0) {
    agentList = Object.keys(listingInfo.agents).map(key => {
      const agent = listingInfo.agents[key];
      return (
        <div className="chat-detail-phone-item" key={key}>
          <span>{agent.first_name_en}</span>
          <a href={`tel:${agent.mobile || agent.telephone}`} className="button">
            {agent.mobile || agent.telephone}
          </a>
        </div>
      );
    });
  }
  if (Object.keys(listingInfo.offices).length > 0) {
    officeList = Object.keys(listingInfo.offices).map(key => {
      const office = listingInfo.offices[key];
      return (
        <div key={key} className="chat-detail-phone-item">
          <span>{trans.Office}</span>
          <a href={`tel:${office.phone}`} className="button">
            {office.phone}
          </a>
        </div>
      );
    });
  }
  return (
    <div className={`chat-detail-call ${showCallClass}`}>
      <div className="chat-detail-call-box">
        <button className="chat-detail-call-box-close small" onClick={_handleClose} type="button">
          <i className="material-icons">close</i>
        </button>
        <div className="chat-detail-phone-list">
          {agentList}
          {officeList}
        </div>
      </div>
    </div>
  );
};

ChatDetailCall.propTypes = {
  chatCallToggle: PropTypes.func.isRequired,
  showCall: PropTypes.bool.isRequired,
  listingInfo: PropTypes.shape().isRequired,
  trans: PropTypes.shape().isRequired,
};

export default ChatDetailCall;
